import {IdName} from '../../../shared/common-interfaces';
import {isNil} from 'lodash-es';

export interface IIdSNameS {
  id: string;
  name: string;
}

export interface IIdName {
  id: number;
  name: string;
}

export interface IContent {
  id: number;
  vibaContentId?: number;
  retailers: Array<IIdName>;
  project: IIdName;
  products?: Array<IIdName>;
  productTypes?: Array<IIdName>;
  productCategories?: Array<IIdName>;
  storeTypes?: Array<IdName>;
  activityTypes?: Array<IdName>;

  endpointTypes: Array<IdName>;
  languageId: number;
  country?: IIdName;
  states?: Array<IIdName>;
  cities?: Array<string>;
  orientation?: number;
  name: string;
  format: number;
  size?: number;
  duration?: number;
  description?: string;
  type: number[];
  typeName?: string;
  storeId?: number;
  storeName?: string;
  storeNumber?: string;
  s3Link?: string;
  status?: number;
  isActive?: number;
  createdBy?: number;
  updatedBy?: number;
  createdOn?: string;
  updatedOn?: string;
  file?: File;
  version?: string;
  contactDetails?: IContactDetails;
  calendarEventDetails?: ICalendarEventDetails;
  formDetails?: IFormDetails;
  thumbnailLink?: string;
  thumbnailPath?: string;
  isDownloadable?: boolean;
}

export interface IBkInContent {
  name: string;
  format: number;
  size: string;
  duration: string;
  description: string;
  type: number[];
  typeName?: string;
  storeId: number;
  storeName?: string;
  isDownloadable?: boolean;
  products?: Array<IIdName>;
  productTypes?: Array<IIdName>;
  productCategories?: Array<IIdName>;
}

export interface IContentVersion {
  date: string;
  latest: boolean;
  number: number;
  version: string;
}

export interface IContactDetails {
  title: string;
  phoneNumber: number;
  email: string;
  company: string;
  department: string;
}

export interface IFormDetails {
  formId: number;
  guid?: string;
}

export interface ICalendarEventDetails {
  startDate: string;
  endDate: string;
  location: string;
}

export interface IPrplsVals {
  project: string;
  endpointTypes: number[] | IIdName[];
  account: number[] | string[];
  product: number[] | string[];
  language: number;
  orientation: string;
}

export interface IFileUploadVals {
  importFile: string;
  city: number[] | string[];
  country: string;
  state: number[] | string[];
  prpls: IPrplsVals;
  content?: IContent;
}

export interface ILinkVals {
  name: string;
  description: string;
  link: string;
  prpls: IPrplsVals;
  content?: IContent;
}

export interface IFormVals {
  name: string;
  description: string;
  form: string;
  prpls: IPrplsVals;
  content?: IContent;
}

export interface IARVals {
  name: string;
  description: string;
  key: string;
  prpls: IPrplsVals;
  content?: IContent;
}


export interface IContactVals {
  company: string;
  department: string;
  name: string;
  description: string;
  email: string;
  phone: string;
  title: string;
  store?: string;
  prpls: IPrplsVals;
  content?: IContent;
}

export interface IContactCalendarEventVals {
  location: string;
  name: string;
  description: string;
  startDate: number;
  endDate: number;
  store?: string;
  prpls: IPrplsVals;
  content?: IContent;
}

export enum ContentTypesEnum {
  VIRTUAL_AGENT_PLAYLIST = 1,
  ON_DEMAND = 2,
  DEFAULT_CONTENT = 6,
  LOGO = 10,
  PRODUCT = 11,
  VOICE_OVER = 12,
  MICROSITE = 13,
  THANK_YOU = 14,
  HELP = 15,
  PURCHASE = 16,
  PRODUCT_TYPE = 17,
  PRODUCT_CATEGORY = 18,
  BACKGROUND = 20,
  BUSY = 21,
  INTRO = 22,
  POPUP_INTRO_SCREEN = 23,
  OUTSIDE_WORKING_HOURS = 24,
  CALLING_SCREEN = 25,
  WELCOME_IMAGE = 26,
  WELCOME_VIDEO = 27,
  PLAYLIST_BANNER = 28,
  STARTUP_AVATAR_IMAGE = 29,
  STARTUP_AVATAR_VIDEO = 30,
  AVATAR_INTRO = 31,
  PRIVACY_POLICY = 32,
  TERMS = 33,
}

export const TYPES = [
  {id: ContentTypesEnum.VIRTUAL_AGENT_PLAYLIST, name: 'Virtual Agent Playlist'},
  {id: ContentTypesEnum.ON_DEMAND, name: 'On-Demand'},
  // {id: ContentTypesEnum.LIVE_AGENT_HOT_WORD, name: 'Live Agent Hot Word'},
  {id: ContentTypesEnum.DEFAULT_CONTENT, name: 'Default Content'},
  // {id: ContentTypesEnum.BROADCAST_RECORDED, name: 'Broadcast Recorded'},
  {id: ContentTypesEnum.LOGO, name: 'Logo'},
  {id: ContentTypesEnum.PRODUCT, name: 'Product'},
  {id: ContentTypesEnum.PRODUCT_TYPE, name: 'Product Type'},
  {id: ContentTypesEnum.PRODUCT_CATEGORY, name: 'Product Category'},
  {id: ContentTypesEnum.PRIVACY_POLICY, name: 'Privacy Policy'},
  {id: ContentTypesEnum.TERMS, name: 'Terms & Conditions'},
  {id: ContentTypesEnum.VOICE_OVER, name: 'Voice Over'},
  {id: ContentTypesEnum.MICROSITE, name: 'Microsite'},
  {id: ContentTypesEnum.THANK_YOU, name: 'Thank You'},
  {id: ContentTypesEnum.HELP, name: 'Help'},
  {id: ContentTypesEnum.PURCHASE, name: 'Purchase'},
  // {id: ContentTypesEnum.SMART_SIGN, name: 'Smart Sign Settings'},
  {id: ContentTypesEnum.BACKGROUND, name: 'Agent Background'},
  {id: ContentTypesEnum.BUSY, name: 'Busy'},
  {id: ContentTypesEnum.INTRO, name: 'Intro'},
  {id: ContentTypesEnum.POPUP_INTRO_SCREEN, name: 'Pop-up Intro'},
  {id: ContentTypesEnum.OUTSIDE_WORKING_HOURS, name: 'Outside Working Hours'},
  {id: ContentTypesEnum.CALLING_SCREEN, name: 'Calling screen'},
  {id: ContentTypesEnum.WELCOME_IMAGE, name: 'Welcome Image'},
  {id: ContentTypesEnum.WELCOME_VIDEO, name: 'Welcome Video'},
  {id: ContentTypesEnum.PLAYLIST_BANNER, name: 'Playlist Banner'},
  {id: ContentTypesEnum.STARTUP_AVATAR_IMAGE, name: 'Startup Avatar Image'},
  {id: ContentTypesEnum.STARTUP_AVATAR_VIDEO, name: 'Startup Avatar Video'},
  {id: ContentTypesEnum.AVATAR_INTRO , name: 'Avatar Intro'},
];

export function contentTypeNames(typeIds: number[]): string {
  if(isNil(typeIds)) {
    return null;
  }
  return TYPES.filter(type => typeIds.includes(type.id)).map(type => type.name).join(', ');
}

export enum FileFormatsEnum {
  Image = 1,
  Video = 2,
  Document = 3,
  Contact = 4,
  Link = 5,
  CalendarEvent = 6,
  Web = 7,
  AugmentedReality = 8,
  Form = 10,
}

export const AVAILABLE_FILE_FORMATS =
  [
    {
      id: FileFormatsEnum.Image,
      name: 'Image',
      types: [ContentTypesEnum.LOGO,
              ContentTypesEnum.PRODUCT,
              ContentTypesEnum.PRODUCT_TYPE,
              ContentTypesEnum.PRODUCT_CATEGORY,
              ContentTypesEnum.ON_DEMAND,
              ContentTypesEnum.VOICE_OVER,
              ContentTypesEnum.BACKGROUND,
              ContentTypesEnum.DEFAULT_CONTENT,
              ContentTypesEnum.MICROSITE,
              ContentTypesEnum.WELCOME_IMAGE,
              ContentTypesEnum.PLAYLIST_BANNER,
              ContentTypesEnum.STARTUP_AVATAR_IMAGE
      ],
      extensions: ['png', 'jpg', 'svg','gif'],
      withThumbnail: true,
      withHistory: true,
    },
    {
      id: FileFormatsEnum.Video,
      name: 'Video',
      types: [
              ContentTypesEnum.VIRTUAL_AGENT_PLAYLIST,
              ContentTypesEnum.PRODUCT,
              ContentTypesEnum.PRODUCT_TYPE,
              ContentTypesEnum.PRODUCT_CATEGORY,
              ContentTypesEnum.ON_DEMAND,
              ContentTypesEnum.CALLING_SCREEN,
              ContentTypesEnum.MICROSITE,
              ContentTypesEnum.WELCOME_VIDEO,
              ContentTypesEnum.STARTUP_AVATAR_VIDEO,
              ContentTypesEnum.AVATAR_INTRO
      ],
      extensions: ['mp4', 'webm', 'mov'],
      withThumbnail: true,
      withHistory: true,
    },
    {
      id: FileFormatsEnum.Document,
      name: 'Document',
      types: [ContentTypesEnum.PRODUCT,
              ContentTypesEnum.PRODUCT_TYPE,
              ContentTypesEnum.PRODUCT_CATEGORY,
              ContentTypesEnum.MICROSITE,
              ContentTypesEnum.PRIVACY_POLICY,
              ContentTypesEnum.TERMS],
      extensions: ['pdf'],
      withThumbnail: true,
      withHistory: true,
    },
    {
      id: FileFormatsEnum.Contact,
      name: 'Contact',
      types: [ContentTypesEnum.MICROSITE,
              ContentTypesEnum.PRODUCT,
              ContentTypesEnum.PRODUCT_TYPE,
              ContentTypesEnum.PRODUCT_CATEGORY,
            ],
      extensions: ['vcf', 'vcard'],
      withThumbnail: false,
      withHistory: false,
    },
    {
      id: FileFormatsEnum.Link,
      name: 'Link',
      types: [ContentTypesEnum.MICROSITE,
        ContentTypesEnum.PRODUCT,
        ContentTypesEnum.PRODUCT_TYPE,
        ContentTypesEnum.PRODUCT_CATEGORY,
      ],
      extensions: [],
      withThumbnail: false,
      withHistory: false,
    },
    {
      id: FileFormatsEnum.CalendarEvent,
      name: 'Calendar Event',
      types: [ContentTypesEnum.MICROSITE,
        ContentTypesEnum.PRODUCT,
        ContentTypesEnum.PRODUCT_TYPE,
        ContentTypesEnum.PRODUCT_CATEGORY,
      ],
      extensions: ['ical'],
      withThumbnail: false,
      withHistory: false,
    },
    {
      id: FileFormatsEnum.Web,
      name: 'Web',
      types: [ContentTypesEnum.PRODUCT,
              ContentTypesEnum.PRODUCT_TYPE,
              ContentTypesEnum.PRODUCT_CATEGORY,
              ContentTypesEnum.DEFAULT_CONTENT,
              ContentTypesEnum.THANK_YOU,
              ContentTypesEnum.INTRO,
              ContentTypesEnum.POPUP_INTRO_SCREEN,
              ContentTypesEnum.OUTSIDE_WORKING_HOURS,
              ContentTypesEnum.BUSY,
              ContentTypesEnum.HELP,
              ContentTypesEnum.PURCHASE],
      extensions: ['htm', 'html', 'xml'],
      withThumbnail: false,
      withHistory: true,
    },
    {
      id: FileFormatsEnum.AugmentedReality,
      name: 'Augmented Reality',
      types: [ContentTypesEnum.MICROSITE,
        ContentTypesEnum.PRODUCT,
        ContentTypesEnum.PRODUCT_TYPE,
        ContentTypesEnum.PRODUCT_CATEGORY,
      ],
      extensions: [],
      withThumbnail: false,
      withHistory: false,
    },
    {
      id: FileFormatsEnum.Form,
      name: 'Form',
      types: [ContentTypesEnum.MICROSITE,
        ContentTypesEnum.PRODUCT,
        ContentTypesEnum.PRODUCT_TYPE,
        ContentTypesEnum.PRODUCT_CATEGORY,
      ],
      extensions: [],
      withThumbnail: false,
      withHistory: false,
    },
  ];


export const ORIENTATIONS = [
  {id: '1', name: 'Portrait'},
  {id: '2', name: 'Landscape'},
];

export enum ContentEditMode {
  STATUS = 1,
  VERSION = 2,
  NEW_CONTENT = 3,
  METADATA = 4,
  THUMBNAIL = 5,
}

export enum ContentStatus {
  PENDING = 1,
  ACTIVE = 2,
  SUSPENDED = 3,
  ARCHIVED = 4,
}

export const CONTENT_STATUSES = [
  {
    id: ContentStatus.ACTIVE,
    name: 'Active',
  },
  {
    id: ContentStatus.PENDING,
    name: 'Pending',
  },
  {
    id: ContentStatus.SUSPENDED,
    name: 'Suspended',
  },
  {
    id: ContentStatus.ARCHIVED,
    name: 'Archived',
  },
];
